import React, { useRef, useEffect } from "react";
import {Container, Typography} from "@mui/material";
import Box from "@mui/material/Box";

export default function SectionJeune() {
    const iframeRef = useRef(null);

    useEffect(() => {
        function handleMessage(e) {
            // Sécurité : n'accepter que les messages provenant de helloasso
            try {
                const allowedOrigin = "https://www.helloasso.com";
                if (!e.origin || !e.origin.startsWith(allowedOrigin)) return;

                const data = e.data;
                let newHeight = null;

                if (data && typeof data === "object" && data.height) {
                    newHeight = parseInt(data.height, 10);
                } else if (typeof data === "string") {
                    const parsed = parseInt(data, 10);
                    if (!Number.isNaN(parsed)) newHeight = parsed;
                }

                if (newHeight && iframeRef.current) {
                    // ajouter un petit padding pour éviter scrolls
                    const minHeight = 400;
                    iframeRef.current.style.height = Math.max(newHeight, minHeight) + "px";
                }
            } catch (err) {
                // silencieux
            }
        }

        window.addEventListener("message", handleMessage, false);
        return () => window.removeEventListener("message", handleMessage, false);
    }, []);

  return (
      <Container>
          <Box sx={{
              backgroundColor: '#fbfdff', // léger fond bleu très pâle
              p: {xs: 2, md: 4},
              borderRadius: 3,
              boxShadow: 2,
              maxWidth: '100%',
              margin: '3em auto 28px',
              display: 'flex',
              flexDirection: 'column',
              gap: 1.5,
              textAlign: {xs: 'left', md: 'justify'}
          }}>
              {/* Accent coloré à gauche + petit titre */}
              <Box sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                  <Box sx={{width: 8, height: 40, backgroundColor: '#df0707cf', borderRadius: 1}}/>
                  <Typography variant="h6" sx={{fontWeight: 700, letterSpacing: 0.2}}>La section jeune de la vitréenne
                      volley-ball</Typography>
              </Box>

              <Typography variant="body1" sx={{
                  whiteSpace: 'pre-line',
                  lineHeight: 1.5,
                  color: 'text.primary',
                  fontSize: {xs: '0.95rem', md: '1.15rem'},
                  width: '100%'
              }}>
                  Depuis plusieurs années, La Vitréenne Volley souhaitait ouvrir une section jeunes. Cette année, c'est
                  chose faite et nous sommes heureux d'annoncer l'ouverture de la section jeune ! Cette section
                  s'adresse aux catégories M9 (nés en 2018/2019) et M11 (nés en 2016/2017).
                  <br/>Les séances auront lieu au complexe sportif des Promenades, les mercredis de 14h à 16h, avec des
                  créneaux de 1h15 par catégorie. Elles seront encadrées par un éducateur certifié de Vitré Communauté
                  et par des bénévoles du club.
                  <br/>Des séances d'essai seront possibles afin que chaque famille puisse découvrir le fonctionnement
                  du groupe.
                  <br/>Pour toute question, contactez‑nous ou venez nous rencontrer.
                  <br/><br/>
                  Pour vous pré-inscrire, rien de plus simple : cliquez sur le lien ci dessous et laissez-vous
                  guider !
              </Typography>
              <iframe
                  id="haWidgetButton"
                  ref={iframeRef}
                  allowTransparency="true"
                  src="https://www.helloasso.com/associations/la-vitreenne-volley-ball/adhesions/pre-inscriptions-section-jeune-2026-2027/widget-bouton"
                  style={{width: '100%' , height: '70px' , border: 'none'}}
              />
          </Box>
      </Container>
  );
}
